function defaultNoopBatch(callback) {
  callback();
}
var batch = defaultNoopBatch;
export var setBatch = function setBatch2(newBatch) {
  return batch = newBatch;
};
export var getBatch = function getBatch2() {
  return batch;
};
